<template>
	<div><div class="box" v-html="detail"></div></div>
</template>

<script>
export default {
	name: 'agreement',
	data() {
		return {
			detail: ''
		};
	},
	created() {
		this.type = this.$route.query.type;
		this.getAgreement();
	},
	methods: {
		getAgreement() {
			this.$api.agreement({ type: this.type }).then((res) => {
				console.log(res);
				if (res.result == 0) {
					this.detail = res.data.detail;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.box {
	margin: 100px auto 0;
	::v-deep p {
		font-size: 24px;
		color: #2efeff;
	}
	::v-deep img {
		width: 100%;
		display: block;
	}
}
</style>
